import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LayoutComponent} from './components/layout/layout.component';
import {AuthGuard} from './guards/auth.guard';
import {HomeComponent} from './components/home/home.component';
import {LoginComponent} from './components/auth/login/login.component';
import {GuestGuard} from './guards/guest.guard';
import {MerchantsComponent} from './components/merchants/merchants.component';
import {CategoriesComponent} from './components/categories/categories.component';
import {CategoryAddEditComponent} from './components/categories/category-add-edit/category-add-edit.component';
import {MerchantAddEditComponent} from './components/merchants/merchant-add-edit/merchant-add-edit.component';
import {ProductsComponent} from './components/products/products.component';
import {ProductAddEditComponent} from './components/products/product-add-edit/product-add-edit.component';
import {OrdersComponent} from './components/orders/orders.component';
import {BankAccountsComponent} from './components/bank-accounts/bank-accounts.component';
import {BankAccountAddEditComponent} from './components/bank-accounts/bank-account-add-edit/bank-account-add-edit.component';
import {CustomersComponent} from "./components/customers/customers.component";
import {BrandsComponent} from "./components/brands/brands.component";
import {BrandAddEditComponent} from "./components/brands/brand-add-edit/brand-add-edit.component";
import {BrandTypeProductsComponent} from "./components/brand-type-products/brand-type-products.component";
import {BrandTypeProductAddEditComponent} from "./components/brand-type-products/brand-type-product-add-edit/brand-type-product-add-edit.component";
import {BrandSubTypeProductsComponent} from "./components/brand-sub-type-products/brand-sub-type-products.component";
import {BrandSubTypeProductAddEditComponent} from "./components/brand-sub-type-products/brand-sub-type-product-add-edit/brand-sub-type-product-add-edit.component";
import {BannersComponent} from "./components/banners/banners.component";
import {BannersAddEditComponent} from "./components/banners/banners-add-edit/banners-add-edit.component";
import { SubscriptionsComponent } from './components/subscriptions/subscriptions.component';
import { CouponsComponent } from './components/coupons/coupons.component';
import { AddEditCouponsComponent } from './components/coupons/add-edit-coupons/add-edit-coupons.component';

const routes: Routes = [
    {
        path: '', component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {path: '', component: HomeComponent},
            // Products
            {path: 'orders', component: OrdersComponent},

            // Customers
            {path: 'customers', component: CustomersComponent},

            // Merchants
            {path: 'merchants', component: MerchantsComponent},
            {path: 'merchants/create', component: MerchantAddEditComponent},
            {path: 'merchants/edit/:id', component: MerchantAddEditComponent},

            // bank Accounts
            {path: 'bank-accounts', component: BankAccountsComponent},
            {path: 'bank-accounts/create', component: BankAccountAddEditComponent},
            {path: 'bank-accounts/edit/:id', component: BankAccountAddEditComponent},

            // Categories
            {path: 'categories', component: CategoriesComponent},
            {path: 'categories/create', component: CategoryAddEditComponent},
            {path: 'categories/edit/:id', component: CategoryAddEditComponent},

            //Brands
            {path:'brands', component: BrandsComponent},
            {path:'brands/create', component: BrandAddEditComponent},
            {path:'brands/edit/:id', component: BrandAddEditComponent},

            //Brand Type Products
            {path:'brand-type-products', component: BrandTypeProductsComponent},
            {path:'brand-type-products/create', component: BrandTypeProductAddEditComponent},
            {path:'brand-type-products/edit/:id', component: BrandTypeProductAddEditComponent},

            //Brand Sub Type Products
            {path: 'brand-sub-type-products', component: BrandSubTypeProductsComponent},
            {path: 'brand-sub-type-products/create', component: BrandSubTypeProductAddEditComponent},
            {path: 'brand-sub-type-products/edit/:id', component: BrandSubTypeProductAddEditComponent},

            // Products
            {path: 'products', component: ProductsComponent},
            {path: 'products/create', component: ProductAddEditComponent},
            {path: 'products/edit/:id', component: ProductAddEditComponent},

            // Banners
            {path: 'banners', component: BannersComponent},
            {path: 'banners/create', component: BannersAddEditComponent},
            {path: 'banners/edit/:id', component: BannersAddEditComponent},

            // Subscriptions
            {path: 'subscriptions', component: SubscriptionsComponent},

            //Coupons
            {path: 'coupons', component: CouponsComponent},
            {path: 'coupons/create', component: AddEditCouponsComponent},
            {path: 'coupons/edit/:id', component: AddEditCouponsComponent},

        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [GuestGuard]
    },
    // otherwise redirect to home
    {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
